// Last modification dates are derived from page sources during sitemap generation.
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      sitemap: {
        priority: 1.0,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/Brand.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/Service.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/friends',
    name: 'friends',
    component: () => import('@/views/Friends.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: () => import('@/views/Catalog.vue'),
    meta: {
      sitemap: {
        priority: 0.7,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/Products'),
    meta: {
      sitemap: {
        priority: 0.9,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/products/kitchens',
    name: 'products-kitchens',
    component: () => import('@/views/Products/Kitchens'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/products/wardrobes',
    name: 'products-wardrobes',
    component: () => import('@/views/Products/Wardrobes'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  // {
  //   path: '/products/bathrooms',
  //   name: 'products-bathrooms',
  //   component: () => import('@/views/Products/Bathrooms'),
  //   meta: {
  //     sitemap: {
  //       priority: 0.8,
  //       changefreq: 'weekly'
  //     }
  //   }
  // },
  {
    path: '/products/sofas',
    name: 'products-sofas',
    component: () => import('@/views/Products/Sofas'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/products/sofas/platform',
    name: 'products-sofa-platform',
    component: () => import('@/views/Products/Sofas/Platform.vue')
  },
  {
    path: '/products/sofas/piano',
    name: 'products-sofa-piano',
    component: () => import('@/views/Products/Sofas/Piano.vue')
  },
  {
    path: '/products/sofas/sierra',
    name: 'products-sofa-sierra',
    component: () => import('@/views/Products/Sofas/Sierra.vue')
  },
  {
    path: '/products/sofas/wave',
    name: 'products-sofa-wave',
    component: () => import('@/views/Products/Sofas/Wave.vue')
  },
  {
    path: '/products/sofas/dune',
    name: 'products-sofa-dune',
    component: () => import('@/views/Products/Sofas/Dune.vue')
  },
  {
    path: '/products/sofas/haven',
    name: 'products-sofa-haven',
    component: () => import('@/views/Products/Sofas/Haven.vue')
  },
  {
    path: '/products/sofas/monfort',
    name: 'products-sofa-monfort',
    component: () => import('@/views/Products/Sofas/Monfort.vue')
  },
  {
    path: '/products/sofas/lowell',
    name: 'products-sofa-lowell',
    component: () => import('@/views/Products/Sofas/Lowell.vue')
  },
  {
    path: '/sofas',
    redirect: '/products/sofas',
    meta: { sitemap: { ignoreRoute: true } }
  },
  {
    path: '/sofas/platform',
    redirect: '/products/sofas/platform',
    meta: { sitemap: { ignoreRoute: true } }
  },
  {
    path: '/production/*',
    redirect: to => to.path.replace('/production', '/products')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/Contacts.vue'),
    meta: {
      sitemap: {
        priority: 0.9,
        changefreq: 'weekly'
      }
    }
  },
  // {
  //   path: '/documents',
  //   name: 'documents',
  //   component: () => import('@/components/Documents')
  // },
  // {
  //   path: '/process',
  //   name: 'process',
  //   component: () => import('@/views/Process.vue')
  // },
  // {
  //   path: '/service',
  //   name: 'service',
  //   component: () => import('@/views/Service.vue')
  // },
  // {
  //   path: '/showrooms',
  //   name: 'showrooms',
  //   component: () => import('@/views/Showrooms.vue')
  // },
  // {
  //   path: '/materials',
  //   name: 'materials',
  //   component: () => import('@/views/Materials.vue')
  // },
  // {
  //   path: '/materials/front',
  //   name: 'front',
  //   component: () => import('@/views/Materials/Front.vue')
  // },
  // {
  //   path: '/materials/front/laminate',
  //   name: 'laminate',
  //   component: () => import('@/components/Materials/sections/Front/Laminate')
  // },
  // {
  //   path: '/materials/front/enamel',
  //   name: 'enamel',
  //   component: () => import('@/components/Materials/sections/Front/Enamel')
  // },
  // {
  //   path: '/materials/front/veneer',
  //   name: 'veneer',
  //   component: () => import('@/components/Materials/sections/Front/Veneer')
  // },
  // {
  //   path: '/materials/front/glass',
  //   name: 'glass',
  //   component: () => import('@/components/Materials/sections/Front/Glass')
  // },
  // {
  //   path: '/materials/front/ceramics',
  //   name: 'ceramics',
  //   component: () => import('@/components/Materials/sections/Front/Ceramics')
  // },
  // {
  //   path: '/materials/tabletop',
  //   name: 'tabletop',
  //   component: () => import('@/views/Materials/Tabletop.vue')
  // },
  // {
  //   path: '/materials/tabletop/plastic',
  //   name: 'plastic',
  //   component: () => import('@/components/Materials/sections/Tabletop/Plastic')
  // },
  // {
  //   path: '/materials/tabletop/mineral',
  //   name: 'mineral',
  //   component: () => import('@/components/Materials/sections/Tabletop/Mineral')
  // },
  // {
  //   path: '/materials/tabletop/quartz',
  //   name: 'quartz',
  //   component: () => import('@/components/Materials/sections/Tabletop/Quartz')
  // },
  // {
  //   path: '/materials/tabletop/stone',
  //   name: 'stone',
  //   component: () => import('@/components/Materials/sections/Tabletop/Stone')
  // },
  // {
  //   path: '/materials/tabletop/ceramics',
  //   name: 'ceramics-tt',
  //   component: () => import('@/components/Materials/sections/Tabletop/Ceramics')
  // },
  // {
  //   path: '/materials/tabletop/steel',
  //   name: 'steel',
  //   component: () => import('@/components/Materials/sections/Tabletop/Steel')
  // },
  // {
  //   path: '/materials/tabletop/wood',
  //   name: 'wood',
  //   component: () => import('@/components/Materials/sections/Tabletop/Wood')
  // },
  // {
  //   path: '/materials/equipment',
  //   name: 'equipment',
  //   component: () => import('@/views/Materials/Equipment.vue')
  // },
  // {
  //   path: '/materials/carcass',
  //   name: 'carcass',
  //   component: () => import('@/views/Materials/Carcass.vue')
  // },
  {
    path: '/catalog/diorama',
    name: 'diorama',
    component: () => import('@/views/Catalog/Diorama.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/panorama',
    name: 'panorama',
    component: () => import('@/views/Catalog/Panorama.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/chloe',
    name: 'chloe',
    component: () => import('@/views/Catalog/Chloe.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/harizma',
    name: 'harizma',
    component: () => import('@/views/Catalog/Harizma.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/monolith',
    name: 'monolith',
    component: () => import('@/views/Catalog/Monolith.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/esthetic',
    name: 'esthetic',
    component: () => import('@/views/Catalog/Esthetic.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/epoch',
    name: 'epoch',
    component: () => import('@/views/Catalog/Epoch.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/elsa',
    name: 'elsa',
    component: () => import('@/views/Catalog/Elsa.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/alpa',
    name: 'alpa',
    component: () => import('@/views/Catalog/Alpa.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/royce',
    name: 'royce',
    component: () => import('@/views/Catalog/Royce.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/phantom',
    name: 'phantom',
    component: () => import('@/views/Catalog/Phantom.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/edge',
    name: 'edge',
    component: () => import('@/views/Catalog/Edge.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/catalog/rail',
    name: 'rail',
    component: () => import('@/views/Catalog/Rail.vue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/design',
    name: 'design',
    component: () => import('@/views/Design.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/contract',
    name: 'contract',
    component: () => import('@/views/Contract.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/interior',
    name: 'interior',
    component: () => import('@/views/Interior.vue'),
    meta: {
      sitemap: {
      }
    }

  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/views/Projects.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/vorobyev_dom',
    name: 'projectVorobyevDom',
    component: () => import('@/components/Projects/VorobyevDom'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/sady_pekina',
    name: 'projectSadyPekina',
    component: () => import('@/components/Projects/SadyPekina'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/neva_towers',
    name: 'projectNevaTowers',
    component: () => import('@/components/Projects/NevaTowers'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/chloerail_artplay',
    name: 'projectChloerailArtplay',
    component: () => import('@/components/Projects/ChloerailArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/poklonnaya9',
    name: 'projectPoklonnaya9',
    component: () => import('@/components/Projects/Poklonnaya9'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/base_artplay',
    name: 'projectBaseArtplay',
    component: () => import('@/components/Projects/BaseArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/serebryanyi_park',
    name: 'projectSerebryanyiPark',
    component: () => import('@/components/Projects/SerebryanyiPark'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/panorama_home',
    name: 'projectPanoramaHome',
    component: () => import('@/components/Projects/PanoramaHome'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/chloe_home',
    name: 'projectChloeHome',
    component: () => import('@/components/Projects/ChloeHome'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/nagore12',
    name: 'projectNagore12',
    component: () => import('@/components/Projects/Nagore12'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/elsa_artplay',
    name: 'projectElsaArtplay',
    component: () => import('@/components/Projects/ElsaArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/panorama_artplay',
    name: 'projectPanoramaArtplay',
    component: () => import('@/components/Projects/PanoramaArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/izmailovsky_bulvar',
    name: 'projectIzmailovskyBulvar',
    component: () => import('@/components/Projects/IzmailovskyBulvar'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/leninsky38',
    name: 'projectLeninsky38',
    component: () => import('@/components/Projects/Leninsky38'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/truvil',
    name: 'projectTruvil',
    component: () => import('@/components/Projects/Truvil'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/urickogo_wardrobe',
    name: 'projectUrickogoWardrobe',
    component: () => import('@/components/Projects/UrickogoWardrobe'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/sady_pekina_logica',
    name: 'projectsSadyPekinaLogica',
    component: () => import('@/components/Projects/SadyPekinaLogica'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/klokovo',
    name: 'projectsKlokovo',
    component: () => import('@/components/Projects/Klokovo'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/phantom_artplay',
    name: 'projectPhantomArtplay',
    component: () => import('../components/Projects/PhantomArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/ivana_franko',
    name: 'projectIvanaFranko',
    component: () => import('../components/Projects/IvanaFranko'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/vtb_arena_park',
    name: 'projectVTBArenaPark',
    component: () => import('../components/Projects/VTBArenaPark'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/lefortovo_park',
    name: 'projectLefortovoPark',
    component: () => import('../components/Projects/LefortovoPark'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/hidden',
    name: 'projectHidden',
    component: () => import('../components/Projects/Hidden'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/jazz',
    name: 'projectJazz',
    component: () => import('../components/Projects/Jazz'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/gray_tones',
    name: 'projectGrayTones',
    component: () => import('../components/Projects/GrayTones'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/river_park',
    name: 'projectRiverPark',
    component: () => import('../components/Projects/RiverPark'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/park_avenue',
    name: 'projectParkAvenue',
    component: () => import('../components/Projects/ParkAvenue'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/geometriya',
    name: 'projectGeometriya',
    component: () => import('../components/Projects/Geometriya'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/chloe_artplay',
    name: 'projectChloeArtplay',
    component: () => import('../components/Projects/ChloeArtplay'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/vtb_apartments',
    name: 'projectVTBApartments',
    component: () => import('../components/Projects/VTBApartments'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/nemchinovo',
    name: 'projectNemchinovo',
    component: () => import('../components/Projects/Nemchinovo'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/architects_residences',
    name: 'projectArchitectsResidences',
    component: () => import('../components/Projects/ArchitectsResidences'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/life_kutuzovskiy',
    name: 'projectLifeKutuzovskiy',
    component: () => import('../components/Projects/LifeKutuzovskiy'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/tsvetnoi_bulvar',
    name: 'projectTsvetnoiBulvar',
    component: () => import('../components/Projects/TsvetnoiBulvar'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/usovo_park',
    name: 'projectUsovoPark',
    component: () => import('../components/Projects/UsovoPark'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/norway',
    name: 'projectNorway',
    component: () => import('../components/Projects/Norway'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/chernyahovskogo_19',
    name: 'projectChernyahovskogo19',
    component: () => import('../components/Projects/Chernyahovskogo19'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/urickogo',
    name: 'projectsUrickogo',
    component: () => import('../components/Projects/Urickogo'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/poroshino',
    name: 'projectsPoroshino',
    component: () => import('../components/Projects/Poroshino'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/projects/capital',
    name: 'projectsCapital',
    component: () => import('../components/Projects/Capital'),
    meta: {
      sitemap: {
        priority: 0.5,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/application',
    name: '/application',
    component: () => import('@/components/Application'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  {
    path: '/applicationaccepted',
    name: 'applicationaccepted',
    component: () => import('@/components/Application/Accept'),
    meta: {
      sitemap: {
        ignoreRoute: true
      }
    }

  },
  {
    path: '/cl-accepted',
    name: 'cl-accepted',
    component: () => import('@/components/Application/AcceptCL'),
    meta: {
      sitemap: {
        ignoreRoute: true
      }
    }

  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('@/components/Application/Personal'),
    meta: {
      sitemap: {
        ignoreRoute: true
      }
    }

  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/components/Documents/Policy'),
    meta: {
      sitemap: {
      }
    }

  },
  {
    path: '/capital-living',
    name: 'capital-living',
    component: () => import('@/components/CapitalLiving'),
    meta: {
      sitemap: {
        ignoreRoute: true
      }
    }

  },
  {
    path: '/taplink',
    name: 'taplink',
    component: () => import('@/views/Taplink.vue'),
    meta: {
      sitemap: {
        ignoreRoute: true
      }
    }

  },
  // {
  //   path: '/prices',
  //   name: 'prices',
  //   component: () => import('@/views/Prices.vue')
  // },

  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound'),
    meta: { sitemap: { ignoreRoute: true } }
  },
  {
    path: '/ceramics',
    name: 'ceramics',
    component: () => import('@/components/Ceramics/index.vue'),
    meta: {
      sitemap: {
        priority: 0.8,
        changefreq: 'weekly'
      }
    }
  },
  { path: '/ceramics/ananda', name: 'ceramics-ananda', component: () => import('@/components/Ceramics/ANANDA/index.vue') },
  { path: '/ceramics/ares', name: 'ceramics-ares', component: () => import('@/components/Ceramics/ARES/index.vue') },
  { path: '/ceramics/atalaia', name: 'ceramics-atalaia', component: () => import('@/components/Ceramics/ATALAIA/index.vue') },
  { path: '/ceramics/atria', name: 'ceramics-atria', component: () => import('@/components/Ceramics/ATRIA/index.vue') },
  { path: '/ceramics/azalai', name: 'ceramics-azalai', component: () => import('@/components/Ceramics/AZALAI/index.vue') },
  { path: '/ceramics/brazza', name: 'ceramics-brazza', component: () => import('@/components/Ceramics/BRAZZA/index.vue') },
  { path: '/ceramics/brenta', name: 'ceramics-brenta', component: () => import('@/components/Ceramics/BRENTA/index.vue') },
  { path: '/ceramics/duna', name: 'ceramics-duna', component: () => import('@/components/Ceramics/DUNA/index.vue') },
  { path: '/ceramics/fusion', name: 'ceramics-fusion', component: () => import('@/components/Ceramics/FUSION/index.vue') },
  { path: '/ceramics/geocrema', name: 'ceramics-geocrema', component: () => import('@/components/Ceramics/GEO CREMA/index.vue') },
  { path: '/ceramics/geo', name: 'ceramics-geo', component: () => import('@/components/Ceramics/GEO GRIS/index.vue') },
  { path: '/ceramics/iseo', name: 'ceramics-iseo', component: () => import('@/components/Ceramics/ISEO/index.vue') },
  { path: '/ceramics/jasper', name: 'ceramics-jasper', component: () => import('@/components/Ceramics/JASPER/index.vue') },
  { path: '/ceramics/kaizen', name: 'ceramics-kaizen', component: () => import('@/components/Ceramics/KAIZEN/index.vue') },
  { path: '/ceramics/korten', name: 'ceramics-korten', component: () => import('@/components/Ceramics/KORTEN/index.vue') },
  { path: '/ceramics/larsen', name: 'ceramics-larsen', component: () => import('@/components/Ceramics/LARSEN/index.vue') },
  { path: '/ceramics/lyra', name: 'ceramics-lyra', component: () => import('@/components/Ceramics/LYRA/index.vue') },
  { path: '/ceramics/masaiblanco', name: 'ceramics-masaiblanco', component: () => import('@/components/Ceramics/MASAI BLANCO PLUS/index.vue') },
  { path: '/ceramics/masai', name: 'ceramics-masai', component: () => import('@/components/Ceramics/MASAI PIEDRA/index.vue') },
  { path: '/ceramics/mauna', name: 'ceramics-mauna', component: () => import('@/components/Ceramics/MAUNA/index.vue') },
  { path: '/ceramics/meteora', name: 'ceramics-meteora', component: () => import('@/components/Ceramics/METEORA/index.vue') },
  { path: '/ceramics/nora', name: 'ceramics-nora', component: () => import('@/components/Ceramics/NORA/index.vue') },
  { path: '/ceramics/pacificblanco', name: 'ceramics-pacificblanco', component: () => import('@/components/Ceramics/PACIFIC BLANCO PLUS/index.vue') },
  { path: '/ceramics/pacific', name: 'ceramics-pacific', component: () => import('@/components/Ceramics/PACIFIC GRIS/index.vue') },
  { path: '/ceramics/petra', name: 'ceramics-petra', component: () => import('@/components/Ceramics/PETRA/index.vue') },
  { path: '/ceramics/silkblanco', name: 'ceramics-silkblanco', component: () => import('@/components/Ceramics/SILK BLANCO/index.vue') },
  { path: '/ceramics/silkcamel', name: 'ceramics-silkcamel', component: () => import('@/components/Ceramics/SILK CAMEL/index.vue') },
  { path: '/ceramics/silk', name: 'ceramics-silk', component: () => import('@/components/Ceramics/SILK NEGRO/index.vue') },
  { path: '/ceramics/stormgris', name: 'ceramics-stormgris', component: () => import('@/components/Ceramics/STORM GRIS/index.vue') },
  { path: '/ceramics/storm', name: 'ceramics-storm', component: () => import('@/components/Ceramics/STORM NEGRO/index.vue') },
  { path: '/ceramics/totem', name: 'ceramics-totem', component: () => import('@/components/Ceramics/TOTEM/index.vue') },
  { path: '/ceramics/touche', name: 'ceramics-touche', component: () => import('@/components/Ceramics/TOUCHE/index.vue') },
  { path: '/ceramics/umbra', name: 'ceramics-umbra', component: () => import('@/components/Ceramics/UMBRA/index.vue') },
  { path: '/ceramics/vint', name: 'ceramics-vint', component: () => import('@/components/Ceramics/VINT/index.vue') }
]

module.exports = { routes }
